<template>
  <div>
    <el-form ref="ruleFormRef" :model="form" label-width="100px" :rules="rules" class="demo-ruleForm" :size="formSize"
      status-icon label-position="left">
      <el-form-item label="授权主体" prop="name">
        <el-radio-group v-model="form.authType" disabled class="ml-4">
          <el-radio label="SELF" size="large">个人</el-radio>
          <el-radio label="ENTERPRISE" size="large">公司</el-radio>
          <el-radio label="UNION" size="large">联盟</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="line"></div>
      <div style="margin-bottom: 0.2rem">
        <span>主体信息</span><span style="color: #86909c">（注：请填写最终使用客户全称。如果你是乙方个人或公司，请填写甲方客户全称）</span>
      </div>

      <div style="display: flex;align-items: center;column-gap: 30px;">
        <el-form-item :label="form.authType == 'SELF' ? '联系人姓名' : '客户名称'" prop="authName">
          <el-input v-model="form.authName" :placeholder="form.authType == 'SELF' ? '请输入联系人姓名' : '请输入客户名称'
            " />
        </el-form-item>
        <el-form-item :label="form.authType == 'SELF' ? '身份证号' : '组织代码'" prop="authCard">
          <el-input v-model="form.authCard" :placeholder="form.authType == 'SELF'
              ? '请输入身份证号'
              : '请输入统一社会信用代码'
            " />
        </el-form-item>
      </div>
      <div class="line"></div>
      <div style="margin-bottom: 0.2rem">
        <span>项目信息</span><span style="color: #86909c">（注：请填写商品被应用的项目信息）</span>
      </div>

      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="form.projectName" placeholder="请输入项目名称" />
      </el-form-item>

      <el-form-item label="项目简介" prop="projectRemark">
        <el-input type="textarea" v-model="form.projectRemark" placeholder="请输入项目简介" />
      </el-form-item>
      <div>
        你填写的信息将呈现在授权书上，具有法律效力，确认后无法修改，请认真填写。
      </div>
    </el-form>
    <div style="display: flex; justify-content: center">
      <div class="dataBtnClose" @click="onCancel">取消</div>
      <div class="dataBtnSubmit" @click="onSubmit">确认</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed } from "vue";
import type { FormInstance, FormRules } from "element-plus";
interface RuleForm {
  authType: string;
  authName?: string;
  authCard?: string;
  projectName?: string;
  projectRemark?: string;
}
interface FromData {
  modelValue: RuleForm;
}
const formSize = ref("default");
const emit = defineEmits(["update:modelValue", "close", "submit"]);
const ruleFormRef = ref<FormInstance>();
const props = defineProps<FromData>();

const form = computed({
  get() {
    console.info(props.modelValue);
    if (props.modelValue) return props.modelValue;
    else
      return {
        authType: "SELF",
      };
  },
  set(v) {
    emit("update:modelValue", v);
  },
});
const rules = reactive<FormRules<RuleForm>>({
  authName: [{ required: true, message: "请输入内容", trigger: "blur" }],
  authCard: [{ required: true, message: "请输入内容", trigger: "blur" }],
  projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
  projectRemark: [
    { required: true, message: "请输入项目简介", trigger: "blur" },
  ],
});
const onSubmit = () => {
  emit("submit");
};
const onCancel = () => {
  emit("close");
};
</script>

<style scoped>
@import url(/src/assets/css/com.css);

.uploadDataBox {
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0.3rem auto 0.3rem;
  padding: 0.8rem;
}

.sliderBox {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f5f5f5;
  padding: 0.24rem 0.24rem 0.32rem;
  box-sizing: border-box;
  margin: 0.16rem 0 0.24rem;
}

.upload-demo {
  width: 7.02rem;
}

.dataBtnClose,
.dataBtnSubmit {
  padding: 0.08rem 0.3rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
}

.dataBtnClose {
  border: 1px solid #86909c;
  margin: 0.2rem 0.1rem;
}

.dataBtnSubmit {
  color: #fff;
  background: #C01A26;
  margin: 0.2rem 0.1rem;
}

.other {
  background: rgba(255, 96, 0, 0.2);
  border-radius: 0.28rem;
  opacity: 1;
  font-size: 0.14rem;
  color: #C01A26;
  padding: 0.1rem;
}

.line {
  border: 1px solid #e5e6eb;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

/deep/.el-form-item__label {
  /* width: 1.7rem!important; */
  color: #333333 !important;
  text-align: left !important;
}

/deep/.el-form-item--default {
  font-size: 0.14rem !important;
}
</style>
